import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    submit(event) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            event.target.form.requestSubmit()
        }, event.type === "input" ? 400 : 0)
    }
}
